import { useEffect, useMemo, useState } from "react";
import { ACCOUNT_KNOWN_SUBPATHS } from "../account/accountNav";

function normalizePath(p) {
  const raw = (p || "/").trim();
  const cleaned = raw.replace(/\/+$/, "");
  return cleaned.length ? cleaned : "/";
}

export function parseRoutePath(pathname) {
  const withoutQuery = String(pathname || "/").split("#")[0].split("?")[0];
  const normalized = normalizePath(withoutQuery);
  const parts = normalized.split("/").filter(Boolean);

  if (parts.length === 0) return { path: "/", slug: null, unknownAccount: false };

  const [first, second] = parts;

  if (first === "education") {
    return { path: "/education", slug: second || null, unknownAccount: false };
  }

  if (first === "about") {
    return { path: "/about", slug: second || null, unknownAccount: false };
  }

  if (first === "checkout" && (second === "success" || second === "cancel")) {
    return { path: `/checkout/${second}`, slug: null, unknownAccount: false };
  }

  if (first === "sign-in" || first === "sign-up") {
    return { path: `/${first}`, slug: null, unknownAccount: false };
  }

  if (first === "account") {
    const rest = parts.slice(1).join("/");
    if (!ACCOUNT_KNOWN_SUBPATHS.has(rest)) {
      return { path: "/account", slug: rest || null, unknownAccount: true };
    }
    return {
      path: rest ? `/account/${rest}` : "/account",
      slug: null,
      unknownAccount: false,
    };
  }

  return { path: `/${first}`, slug: null, unknownAccount: false };
}

function parsePathname() {
  return parseRoutePath(window.location.pathname || "/");
}

export default function useRoute() {
  const [route, setRoute] = useState(() => parsePathname());

  useEffect(() => {
    const onPopState = () => setRoute(parsePathname());
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  return useMemo(() => route, [route]);
}
